<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		
		

		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
			<!-- 	<Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button> -->
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading:false,
				
				kaishi:'',
				jieshu:'',
				//设备列表
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//加盟商列表
				alliances: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [
					
					{
						title: '订单id',
						key: 'orderId'
					},
					{
						title: '商品名称',
						key: 'commodityName'
					},{
						title: '商品类型',
						key: 'commodityTypeName'
					},
					{
						title: '应出货数量',
						key: 'number'
					},
					{
						title: '实际出货数量',
						key: 'shipmentNUmber'
					},
					{
						title: '单价',
						key: 'sellPrice',
						render: (h, params) => {
							return h("div",params.row.sellPrice/100)
						}
					},
					{
						title: '总价',
						key: 'sellPrice',
						render: (h, params) => {
							return h("div",params.row.sellPrice/100*params.row.number)
						}
					},
					{
						title: '抽成方式',
						key: 'commissionWay',
						render: (h, params) => {
							if(params.row.commissionWay==0){
								return h("div","总金额")
							}else if(params.row.commissionWay==1){
								return h("div","一级分类")
							}else if(params.row.commissionWay==2){
								return h("div","二级分类")
							}else{
								return h("div","三级分类")
							}
							
						}
					},
					{
						title: '抽成比例',
						key: 'rake',
						render: (h, params) => {
							return h("div",params.row.rake/100+"%")
						}
					},
					
					{
						title: '抽成金额',
						key: 'commissionMoney',
						render: (h, params) => {
							return h("div",params.row.commissionMoney/100)
						}
					},
					{
						title: '出货状态',
						key: 'purchasingPrice',
						render: (h, params) => {
							if(params.row.number==params.row.shipmentNUmber){
								return h("div","正常")
							}else{
								return h("div","异常")
							}
							
						}
					},
					
				],
				data6: [
					/* {
					id: '1',
					name: 'XXX机器人',
					address: '渝北区泰山大道东段',
					isRefrigerate: '冷藏',
					startUsing: '启用',
					state: '正常',
					isStockout: '正常',
					useOperOperator: "XXXX",
					createdTime: '2010-10-10'
				} */
				],
				query: {
					page: '0',
					size: '10',
					id:'',
				}
			}
		},
		methods: {
			
			ret() { //返回上一页
				this.$router.go(-1)
			},
			
			//查询条件
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/queryOrderDetails',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.queryOrderDetails.length
						_this.data6 = data.queryOrderDetails
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
		

		},
		components: {
			page
		},
		created() {
			let _this=this
			_this.query.id=_this.$route.query.orderId
			this.ajaxPage()
		},
		beforeRouteLeave(to, from, next) {
			this.$destroy(); //销毁B的实例
			to.meta.keepAlive = true;
			from.meta.keepAlive=false;
			next()
		}, 
	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		width: 100%;
		display: flex;
		margin:10px;
		.item{
		    margin: 0px 20px 0px 20px;
			display: flex;
			font-size: 20px;
		}
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
		display: flex;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/finance/operOrderDetails.vue